export default function postRefresh()
{
  const el = document.getElementById("refreshed");
  if (el) {
    el.value = el.value === 'no' ? 'yes' : 'no';
    if (el.value === 'no') {
      location.reload();
    }
  }
}
